export const TriggerHelpItemEvent = 'HN-trigger-help-item';
export const HelpBubbleEventName = 'HN-help-bubble';
export const HjelpeskuffClosedEventName = 'HN-hjelpeskuff-closed';
/**
 * Åpner hjelpeskuffen med spesifikk hjelpetekst for en tjeneste.
 */
export const HNeventOpenHjelpeskuff = (options) => {
    const event = new CustomEvent(TriggerHelpItemEvent, {
        detail: {
            tjenesteNavn: options.tjenesteNavn,
            hjelpetekstId: options.hjelpetekstId,
            language: options.language,
        },
    });
    window.dispatchEvent(event);
};
/**
 * Dispatcher en event for åpning av en hjelpeboble.
 */
export const HNeventHelpBubble = (id, action = 'open') => {
    const event = new CustomEvent(HelpBubbleEventName, {
        detail: {
            helpBubbleId: id,
            action: action,
        },
    });
    window.dispatchEvent(event);
};
/**
 * Dispatcher en event for etter at hjelpeskuffen er lukket.
 */
export const HNeventHjelpeskuffClosed = () => {
    const event = new CustomEvent(HjelpeskuffClosedEventName);
    window.dispatchEvent(event);
};
